(function () {
  'use strict';

  var IN_STOCK_API_URL = 'https://api.malbon.com.vn/public/get_inventory_all_stock?low_stock=true';
  var IN_STORE_ONLY_TEXT = 'ONLY STORE STOCK';
  var SOLD_OUT_TEXT = 'Sold out';

  try {
    window.InStockData = window.InStockData || {};
  } catch (error) {
    logWarning('Unable to initialize in-store stock map', error);
    return;
  }

  function logWarning(message, error) {
    try {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn(message, error);
      }
    } catch (ignoredError) {}
  }

  function loadInStockData() {
    try {
      if (typeof window.fetch !== 'function') {
        return Promise.resolve();
      }

      return window
        .fetch(IN_STOCK_API_URL, {
          headers: {
            Accept: 'application/json',
          },
        })
        .then(function (response) {
          if (!response || !response.ok) {
            throw new Error('Unable to load in-store stock data');
          }

          return response.json();
        })
        .then(function (stockItems) {
          try {
            window.InStockData = buildStockMap(stockItems);
            scheduleUpdate();
          } catch (error) {
            logWarning('Unable to process in-store stock data', error);
          }
        })
        .catch(function (error) {
          logWarning('In-store stock data failed to load', error);
        });
    } catch (error) {
      logWarning('In-store stock request failed', error);
      return Promise.resolve();
    }
  }

  function buildStockMap(stockItems) {
    try {
      var stockMap = {};

      if (!Array.isArray(stockItems)) {
        return stockMap;
      }

      stockItems.forEach(function (item) {
        try {
          if (item && item.SKU && Number(item.qty) > 0) {
            stockMap[item.SKU] = true;
          }
        } catch (error) {
          logWarning('Unable to read stock item', error);
        }
      });

      return stockMap;
    } catch (error) {
      logWarning('Unable to build in-store stock map', error);
      return {};
    }
  }

  function hasInStoreStock(product) {
    try {
      var stockData = window.InStockData;

      if (!stockData || !product || !Array.isArray(product.variants)) {
        return false;
      }

      return product.variants.some(function (variant) {
        try {
          return Boolean(variant && variant.sku && stockData[variant.sku]);
        } catch (error) {
          logWarning('Unable to check variant stock', error);
          return false;
        }
      });
    } catch (error) {
      logWarning('Unable to check in-store stock', error);
      return false;
    }
  }

  function parseJsonAttribute(element, attributeName) {
    try {
      if (!element || typeof element.getAttribute !== 'function') {
        return null;
      }

      var value = element.getAttribute(attributeName);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      logWarning('Unable to parse product card data', error);
      return null;
    }
  }

  function getSelectedProductBySwatch(card, products) {
    try {
      if (!card || !Array.isArray(products)) {
        return null;
      }

      var selectedSwatch = card.querySelector('[style*="border-color: gray"]');

      if (!selectedSwatch || !selectedSwatch.parentElement) {
        return null;
      }

      var selectedIndex = Array.prototype.indexOf.call(
        selectedSwatch.parentElement.children,
        selectedSwatch
      );

      return products[selectedIndex] || null;
    } catch (error) {
      logWarning('Unable to find selected swatch product', error);
      return null;
    }
  }

  function getCurrentProduct(card) {
    try {
      var products = parseJsonAttribute(card, 'data-products');
      var product = parseJsonAttribute(card, 'data-product');
      var selectedProduct = getSelectedProductBySwatch(card, products);

      if (selectedProduct) {
        return selectedProduct;
      }

      var titleElement = card && card.querySelector ? card.querySelector('h3') : null;
      var currentTitle = titleElement ? titleElement.textContent.trim() : '';

      if (Array.isArray(products) && currentTitle) {
        var matchedProduct = products.find(function (item) {
          try {
            return item && item.title === currentTitle;
          } catch (error) {
            logWarning('Unable to match product title', error);
            return false;
          }
        });

        if (matchedProduct) {
          return matchedProduct;
        }
      }

      return product;
    } catch (error) {
      logWarning('Unable to get current product card data', error);
      return null;
    }
  }

  function updateSoldOutText(card) {
    try {
      if (!card || typeof card.querySelectorAll !== 'function') {
        return;
      }

      var product = getCurrentProduct(card);
      var replacementText = hasInStoreStock(product) ? IN_STORE_ONLY_TEXT : SOLD_OUT_TEXT;

      card.querySelectorAll('div').forEach(function (element) {
        try {
          var text = element && element.textContent ? element.textContent.trim() : '';

          if (text === SOLD_OUT_TEXT || text === IN_STORE_ONLY_TEXT) {
            element.textContent = replacementText;
          }
        } catch (error) {
          logWarning('Unable to update sold out text', error);
        }
      });
    } catch (error) {
      logWarning('Unable to update product card stock text', error);
    }
  }

  function updateAllCards() {
    try {
      document.querySelectorAll('custom-product-card').forEach(function (card) {
        try {
          updateSoldOutText(card);
        } catch (error) {
          logWarning('Unable to update custom product card', error);
        }
      });
    } catch (error) {
      logWarning('Unable to update product cards', error);
    }
  }

  function scheduleUpdate() {
    try {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(updateAllCards);
      } else {
        window.setTimeout(updateAllCards, 0);
      }
    } catch (error) {
      logWarning('Unable to schedule stock text update', error);
    }
  }

  function setupDomReadyUpdate() {
    try {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleUpdate);
      } else {
        scheduleUpdate();
      }
    } catch (error) {
      logWarning('Unable to setup DOM ready update', error);
    }
  }

  function setupRetryTimer() {
    try {
      var retryCount = 0;
      var retryTimer = window.setInterval(function () {
        try {
          retryCount += 1;
          scheduleUpdate();

          if (Object.keys(window.InStockData || {}).length || retryCount >= 40) {
            window.clearInterval(retryTimer);
          }
        } catch (error) {
          logWarning('Unable to run stock retry update', error);
          window.clearInterval(retryTimer);
        }
      }, 250);
    } catch (error) {
      logWarning('Unable to setup stock retry timer', error);
    }
  }

  function setupMutationObserver() {
    try {
      if (typeof window.MutationObserver !== 'function' || !document.documentElement) {
        return;
      }

      new window.MutationObserver(function () {
        try {
          scheduleUpdate();
        } catch (error) {
          logWarning('Unable to handle product card mutation', error);
        }
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    } catch (error) {
      logWarning('Unable to setup product card observer', error);
    }
  }

  try {
    setupDomReadyUpdate();
    loadInStockData();
    window.addEventListener('load', scheduleUpdate);
    setupRetryTimer();
    setupMutationObserver();
  } catch (error) {
    logWarning('Unable to initialize in-store stock script', error);
  }
})();
